import { combineReducers } from '@reduxjs/toolkit'
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2'
import { persistReducer } from 'redux-persist'
import storage from './core.storage'
import { UTILS_STATE_NAME, utilsReducer, utilsSliceConfig } from '../utils'
import { AUTH_STATE_NAME, authApi, authReducer, authSliceConfig } from '../auth'
import { CURRENCY_STATE_NAME, currencyReducer, currencySliceConfig } from '../currency'
import { PROFILE_STATE_NAME, profileReducer, profileSliceConfig } from '../profile'
import {
  CONVERSATIONS_STATE_NAME,
  conversationsReducer,
  conversationsSliceConfig,
} from '../conversations'
import { APP_STATE_NAME, appReducer, appSliceConfig } from '../app'
import { LOOKUP_STATE_NAME, lookupApi, lookupReducer, lookupSliceConfig } from '../lookup'
import { PACKAGE_STATE_NAME, packageApi, packageReducer, packageSliceConfig } from '../package'
import { userExperienceApi } from '../userExperience'
import { userProfileApi } from '../userProfile'

export const rootReducer = combineReducers({
  /* utils */
  [UTILS_STATE_NAME]: persistReducer(utilsSliceConfig, utilsReducer),
  /* auth */
  [AUTH_STATE_NAME]: persistReducer(authSliceConfig, authReducer),
  /* currency */
  [CURRENCY_STATE_NAME]: persistReducer(currencySliceConfig, currencyReducer),
  /* profile */
  [PROFILE_STATE_NAME]: persistReducer(profileSliceConfig, profileReducer),
  /* conversations */
  [CONVERSATIONS_STATE_NAME]: persistReducer(conversationsSliceConfig, conversationsReducer),
  /* app */
  [APP_STATE_NAME]: persistReducer(appSliceConfig, appReducer),
  /* lookup */
  [LOOKUP_STATE_NAME]: persistReducer(lookupSliceConfig, lookupReducer),
  /* package */
  [PACKAGE_STATE_NAME]: persistReducer(packageSliceConfig, packageReducer),
  /* RTK Query APIs */
  [authApi.reducerPath]: authApi.reducer,
  [lookupApi.reducerPath]: lookupApi.reducer,
  [packageApi.reducerPath]: packageApi.reducer,
  [userExperienceApi.reducerPath]: userExperienceApi.reducer,
  [userProfileApi.reducerPath]: userProfileApi.reducer,
})

export type RootReducer = ReturnType<typeof rootReducer>

const persistConfig = {
  key: 'root',
  storage,
  stateReconciler: autoMergeLevel2,
  whitelist: [],
}

export const persistedReducer = persistReducer<RootReducer>(persistConfig, rootReducer)
